import { useState, useEffect } from "react";
import { TrendingUp, ChevronDown, Star } from "lucide-react";
import { estafetaAxios } from "@/utils/estafetaAxios";
import { API_URL } from "@/utils/apiConfig";

const API = API_URL;

export default function StatsPanel({ token, deliverer, t }) {
  const [stats, setStats] = useState(null);
  const [expanded, setExpanded] = useState(false);

  useEffect(() => {
    estafetaAxios(token).get(`${API}/api/v1/deliverers/app/stats`)
      .then(res => setStats(res.data))
      .catch(() => {});
  }, [token]);

  return (
    <div className="bg-white border-b" data-testid="stats-panel">
      {/* Earnings columns hidden — driver sees deliveries count and rating only */}
      <div className="px-4 py-3 grid grid-cols-3 gap-2 text-center">
        <div>
          <p className="text-lg font-bold text-emerald-700" data-testid="stat-today">{stats?.today_deliveries || 0}</p>
          <p className="text-[10px] text-gray-500 uppercase tracking-wide">{t("today")}</p>
        </div>
        <div>
          <p className="text-lg font-bold text-gray-700" data-testid="stat-total">{stats?.total_deliveries || deliverer.total_deliveries || 0}</p>
          <p className="text-[10px] text-gray-500 uppercase tracking-wide">{t("total")}</p>
        </div>
        <div>
          <div className="flex items-center justify-center gap-0.5">
            <Star className={`w-4 h-4 ${(stats?.avg_rating || deliverer.avg_rating || 0) > 0 ? "text-yellow-400 fill-yellow-400" : "text-gray-300"}`} />
            <p className="text-lg font-bold text-gray-700" data-testid="stat-rating">{(stats?.avg_rating || deliverer.avg_rating || 0).toFixed(1)}</p>
          </div>
          <p className="text-[10px] text-gray-500 uppercase tracking-wide">Rating</p>
        </div>
      </div>
      {stats && (
        <>
          <button
            onClick={() => setExpanded(!expanded)}
            className="w-full text-center py-1.5 text-xs text-gray-400 flex items-center justify-center gap-1 hover:text-gray-600"
            data-testid="stats-expand-btn"
          >
            <TrendingUp className="w-3 h-3" />
            {expanded ? t("hideDetails") : t("showDetails")}
            <ChevronDown className={`w-3 h-3 transition-transform ${expanded ? "rotate-180" : ""}`} />
          </button>
          {expanded && (
            <div className="px-4 pb-3 grid grid-cols-2 gap-2 text-center" data-testid="stats-expanded">
              <div className="bg-gray-50 rounded-lg p-2.5"><p className="text-sm font-bold">{stats.week_deliveries}</p><p className="text-[10px] text-gray-500">{t("weekLabel")}</p></div>
              <div className="bg-emerald-50 rounded-lg p-2.5"><p className="text-sm font-bold text-emerald-700">{stats.total_deliveries}</p><p className="text-[10px] text-emerald-600">{t("totalDeliveries")}</p></div>
            </div>
          )}
        </>
      )}
    </div>
  );
}
